import { VALIDATORS } from '@setvi/shared/enums';
import * as Yup from 'yup';

export const nameValidation = Yup.object({
  name: Yup.string()
    .trim()
    .required('Name is required.')
    .max(VALIDATORS.NAME_MAX_LENGTH)
});

export const skuValidation = Yup.object({
  sku: Yup.string()
    .trim()
    .required('SKU is required.')
    .max(VALIDATORS.NAME_MAX_LENGTH)
});

export const priceValidation = Yup.object({
  price: Yup.string()
    .nullable()
    .min(0, 'Price must be at least 0.')
    .max(VALIDATORS.PRICE, `Price must be at most ${VALIDATORS.PRICE} digits.`)
    .matches(/^$|^(0\.\d+|[1-9]\d*(\.\d+)?)$/, 'Invalide price!')
});

export const manufacturerValidation = Yup.object({
  manufacturer: Yup.string()
    .trim()
    .required('Manufacturer is required.')
    .max(VALIDATORS.NAME_MAX_LENGTH)
});

export const schema = [
  {
    name: 'name',
    schema: nameValidation
  },
  {
    name: 'sku',
    schema: skuValidation
  },
  {
    name: 'manufacturer',
    schema: manufacturerValidation
  },
  {
    name: 'price',
    schema: priceValidation
  }
];
